import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

export const getProjectStats = async () => {
  const res = await apiFetch(`${u}/planner/all`);
  if (!res.ok) return [];
  const items = await res.json();

  // Group by projectName client-side using the all-items endpoint
  const projectMap = {};
  (items || []).forEach(item => {
    const name = item.projectName?.trim() || "(No project)";
    if (!projectMap[name]) {
      projectMap[name] = { name, items: [], done: 0, total: 0, overdue: 0, nextDue: null };
    }
    projectMap[name].items.push(item);
    projectMap[name].total++;
    if (item.status === "DONE" || item.status === "SKIPPED") projectMap[name].done++;

    const today = new Date().toISOString().slice(0, 10);
    const due = item.dueDate || item.eventDate || item.paymentDate;
    if (due && due < today && item.status !== "DONE" && item.status !== "SKIPPED" && item.status !== "CANCELLED") {
      projectMap[name].overdue++;
    }
    if (due && item.status !== "DONE" && item.status !== "SKIPPED" && item.status !== "CANCELLED") {
      if (!projectMap[name].nextDue || due < projectMap[name].nextDue) {
        projectMap[name].nextDue = due;
      }
    }
  });

  return Object.values(projectMap).sort((a, b) => {
    if (b.overdue !== a.overdue) return b.overdue - a.overdue;
    return a.name.localeCompare(b.name);
  });
};
